const VIDEO_ROOT = "video-player";
const REACT_PLAYER_FILE = "react-player-file";
const INSERT_YOUTUBE_BUTTON = "insert-youtube-button";
const INSERT_VIDEO_BUTTON = "insert-video-button";
const INSERT_VIDEO_MODAL = "insert-video-modal";
const INSERT_VIDEO_MODAL_SOURCE_TOGGLE = "insert-video-modal-source-toggle";
const EMBED_TAB_URL_INPUT = "insert-video-modal-url-input";
const EMBED_TAB_SUBMIT_BUTTON = "insert-video-modal-action-button-save";
const UPLOAD_TAB_UPLOAD_BUTTON = "insert-video-modal-custom-video-button";
const SETTINGS_DISABLE_DOWNLOAD_TOGGLE = "settings-download-toggle";
const SETTINGS_SPOILER_TOGGLE = "settings-spoiler-toggle";
export {
  EMBED_TAB_SUBMIT_BUTTON,
  EMBED_TAB_URL_INPUT,
  INSERT_VIDEO_BUTTON,
  INSERT_VIDEO_MODAL,
  INSERT_VIDEO_MODAL_SOURCE_TOGGLE,
  INSERT_YOUTUBE_BUTTON,
  REACT_PLAYER_FILE,
  SETTINGS_DISABLE_DOWNLOAD_TOGGLE,
  SETTINGS_SPOILER_TOGGLE,
  UPLOAD_TAB_UPLOAD_BUTTON,
  VIDEO_ROOT
};
//# sourceMappingURL=data-hooks.js.map
